import React, {Component} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import {Card} from "@irati/ui/src/Layout"
import {Label3} from "@irati/ui/src/Labels"
import id from "@irati/utils/id"
import Button from "@irati/ui/src/Button"
import {minWidthMedia} from "@irati/ui/src/global/media"
import myVote from "@irati/recognition/utils/polls/myVote"
import formatRelativeForOpenPolls from "@irati/recognition/utils/formatRelativeForOpenPolls"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import {clickable} from "@irati/ui/src/global/elevation"
import Trophy from "@irati/ui/src/Trophy"
import CompanyValues from "@irati-web/companyvalues/src/components/CompanyValuesList"

import Leaderboard from "../../Leaderboard"
import TeamList from "../../TeamList"
import {RouterLink, TeamsContainer, FlexRow, BodyContainer} from "../../shared"
import WhoVoted from "../../WhoVoted"
import Title from "./shared/Title"
import Description from "./shared/Description"
import {getPollPath} from "../../../utils/paths"

const CardWrapper = styled.div`
  ${clickable}
  ${Card}{
    box-shadow: none;
  }
`

const TrophyContainer = styled.div`
  min-width: 80px;
  align-self: flex-start;
`

const BodyWrapper = styled.div`
  width: calc(100% - 80px);
  word-wrap: break-word;
`

const When = styled(Label3)`
  white-space: nowrap;
`

const DesktopButton = styled(Button)`
  display: none;
  ${minWidthMedia.phone`
    display: inline-block;
  `}
`

const MobileButton = styled(Button)`
  display: inline-block;
  ${minWidthMedia.phone`
    display: none;
  `}
`

class Poll extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    className: PropTypes.string
  }

  static defaultProps = {
    className: null,
    id: "open-poll"
  }

  render() {
    const {poll, className, intl} = this.props
    const buttonProps = {
      id: id("btn", this.props),
      primary: true,
      full: true
    }
    const haveVoted = !!myVote(poll)

    return (
      <RouterLink to={getPollPath(poll)} scrollToTop={false}>
        <CardWrapper>
          <Card tiny className={className}>
            <FlexRow>
              <TrophyContainer>
                <Trophy src={poll.trophy.href} size="60px" />
              </TrophyContainer>
              <BodyWrapper>
                <BodyContainer>
                  <TeamsContainer>
                    <Label3 uppercase>
                      <TeamList teams={poll.teams.results} showMobileTooltip={false} />
                    </Label3>
                    <When>{formatRelativeForOpenPolls(poll.endsAt, intl)}</When>
                  </TeamsContainer>
                  <Title>{poll.title}</Title>
                  <CompanyValues companyValues={poll.companyValues} limit={1} />
                  <Description>{poll.desc}</Description>
                  <WhoVoted id={id("voted", this.props)} poll={poll} />
                  {haveVoted
                    ? <Leaderboard
                      size={50}
                      align="left"
                      poll={poll}
                      showPill={false}
                      showMobileTooltip={false} />
                    :
                    <DesktopButton {...buttonProps}>
                      <FormattedMessage id="recognition.polls.openPoll.poll.button" />
                    </DesktopButton>
                  }
                </BodyContainer>
              </BodyWrapper>
            </FlexRow>
            {!haveVoted &&
            <MobileButton {...buttonProps}>
              <FormattedMessage id="recognition.polls.openPoll.poll.button" />
            </MobileButton>
            }
          </Card>
        </CardWrapper>
      </RouterLink>
    )
  }
}

export default injectIntl(Poll)
